import React from "react";
import { SvgIcon } from "@mui/material";

export function FolderIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M20,6h-8l-2-2H4C2.9,4,2.01,4.9,2.01,6L2,18c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M20,18L4,18V6h5.17 l2,2H20V18z M18,12H6v-2h12V12z M14,16H6v-2h8V16z" />
    </SvgIcon>
  );
}